export async function getIdentityProvidersByEmail(email) {
  const url = `${window.env.STAMPYT_API_HOST}/identity-providers?email=${email}`
  const response = await fetch(url, {
    headers: {
      'x-api-key': window.env.STAMPYT_API_KEY,
      Accept: 'application/json'
    }
  })

  const data = await response.json()
  return data.providerType
}
